import Chip from '@carvana/ds-chip';
import { ShoppingCart } from 'lucide-react';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Summary, Dashboard } from '|/app/services';
import useAnalyticsContext from '|/hooks/use-analytics-context';

interface CartProps {
  orderSummary?: Summary | null;
  dashboard?: Dashboard | null;
  isOrderSummaryModalOpen?: boolean;
  setIsOrderSummaryModalOpen?: (isOpen: boolean) => void;
}

const Cart: React.FC<CartProps> = ({
  orderSummary = null,
  dashboard = null,
  isOrderSummaryModalOpen = false,
  setIsOrderSummaryModalOpen
}) => {
  const { trackEvent } = useAnalyticsContext();
  const { pathname } = useLocation();

  const hasSection2 = dashboard?.sections?.some(section => section.sectionId === 2);
  const hasIncompleteSection2Steps = dashboard?.steps?.some(
    step => step.section === 2 && step.isEnabled && !step.isComplete
  );
  const allSection1StepsComplete = dashboard?.steps
    ?.filter(step => step.section === 1)
    .every(step => step.isComplete);
  const isInSection2Flow = hasSection2 && hasIncompleteSection2Steps && allSection1StepsComplete;

  // Don't show cart if:
  // - Data hasn't loaded yet (prevents flash)
  // - User in section 2 verification flow
  // - On order-placed page
  // - No vehicle in order summary
  // - Order has been placed
  if (
    !dashboard ||
    !orderSummary ||
    isInSection2Flow ||
    !orderSummary.vehicle ||
    pathname.includes('/order-placed') ||
    orderSummary.orderPlacedDateTime
  ) {
    return null;
  }

  const handleClick = () => {
    trackEvent('pp_header_cart_clicked');
    if (setIsOrderSummaryModalOpen) {
      setIsOrderSummaryModalOpen(true);
    }
  };

  return (
    <Chip
      shape="pill"
      size="default"
      icon={<ShoppingCart size={16} color="currentColor" />}
      iconPosition="left"
      onClick={handleClick}
      selected={isOrderSummaryModalOpen}
      data-analytics-id="pp_header_cart"
    >
      Order Summary
    </Chip>
  );
};

export default Cart;
